import "rxjs"
import $ from "jquery"
import {ajax} from "rxjs/observable/dom/ajax"
import config from "../config"
import {
  ACTION_QUERY_APPLICATIONS_LOADING,
  ACTION_QUERY_APPLICATIONS_ERROR,
  ACTION_QUERY_APPLICATIONS_LOADED,
  PATH_APPLICATIONS
} from "../constants"

const api_server_host = config.api_server_host

const errorHandler = (data) => {
  const action = {
    type: ACTION_QUERY_APPLICATIONS_ERROR,
    payload: data
  }
  return Observable.of(action)
}

const epic = (action$, store)=>
  action$.ofType(ACTION_QUERY_APPLICATIONS_LOADING)
    .mergeMap(action => {


      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      const params = action.payload

      return ajax({
        method: 'GET',
        url: `${api_server_host}${PATH_APPLICATIONS}?${$.param(params)}`,
        headers: {
          Authorization: `${type} ${token}`
        },
        responseType: 'json'
      }).map(data=> {
        return {
          type: ACTION_QUERY_APPLICATIONS_LOADED,
          payload: data.response
        }
      }).catch(errorHandler)

    })

export default epic



// WEBPACK FOOTER //
// ./src/epics/ApplicationsEpic.js